import React from "react";
import DOMPurify from "dompurify";
import Anim from "./Anim";
import { BlogCtaMid, BlogCtaEnd } from "../BlogCtaBanners";

const PROSE_CLASSES = `prose prose-lg max-w-none
  prose-headings:font-serif prose-headings:text-emerald_deep prose-headings:tracking-tight
  prose-h2:text-2xl prose-h2:md:text-3xl prose-h2:mt-10 prose-h2:mb-4
  prose-h3:text-xl prose-h3:mt-8 prose-h3:mb-3
  prose-p:text-text_muted prose-p:leading-relaxed prose-p:mb-4
  prose-li:text-text_muted prose-li:leading-relaxed
  prose-strong:text-emerald_deep prose-strong:font-semibold
  prose-a:text-accent prose-a:no-underline hover:prose-a:underline
  prose-ul:mb-6 prose-ol:mb-6`;

export default function PostContent({ content }) {
  const html = content || "";

  // Split content after 3rd heading to inject mid-article CTA
  const headingRegex = /<h[23][^>]*>/g;
  let match, count = 0, splitIdx = -1;
  while ((match = headingRegex.exec(html)) !== null) {
    count++;
    if (count === 3) { splitIdx = match.index; break; }
  }

  return (
    <section className="py-12 md:py-16" data-testid="post-content">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <Anim>
          {splitIdx > 0 ? (
            <>
              <div className={PROSE_CLASSES}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html.slice(0, splitIdx)) }} />
              <BlogCtaMid />
              <div className={PROSE_CLASSES}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html.slice(splitIdx)) }} />
            </>
          ) : (
            <div className={PROSE_CLASSES}
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
              data-testid="post-body" />
          )}
          <BlogCtaEnd />
        </Anim>
      </div>
    </section>
  );
}
